module.exports = __webpack_public_path__ + "static/media/AU-UQ.dcca6cd0.jpg";